import { CheckoutDiscountProfileAttributesAch } from './checkout-discount-profile-attributes-ach.interface';
import { CheckoutDiscountProfileAttributesCC } from './checkout-discount-profile-attributes-cc.interface';

export interface CheckoutPricing {
  taxRate: number;
  netFirstPaymentAmount: number;
  netTotalAmount: number;
  taxTotalAmount: number;
  offerPricingKey: number;
  paymentProfileCode: string;
  discountProfileAttributes?:
    | CheckoutDiscountProfileAttributesAch
    | CheckoutDiscountProfileAttributesCC;
}
